import React, { useState } from "react";
import { useEffect } from "react";
import { AppState } from "../../enums/AppState";
import "./DebugMenu.scss";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const DEBUG_MENU_ITEM_DEFAULT_TYPE = "radio";

function DebugMenuItem(props) {
  const [selected, setSelected] = useState(props.selected);
  const [type, setType] = useState(props.type || DEBUG_MENU_ITEM_DEFAULT_TYPE);

  useEffect(() => {
    setSelected(!!props.selected);
  }, [props.selected]);

  useEffect(() => {
    setType(props.type || DEBUG_MENU_ITEM_DEFAULT_TYPE);
  }, [props.type]);

  const onSelect = (e) => {
    e.stopPropagation();
    const val = type == DEBUG_MENU_ITEM_DEFAULT_TYPE ? true : !selected;
    setSelected(val);
    if (typeof props.onSelect === "function") {
      props.onSelect(val);
    }
  };

  return (
    <div className={`debug-menu-list-item ${selected ? "selected" : ""}`} onClick={onSelect}>
      <input type={type} checked={selected} />
      &nbsp;
      <label>{props.label}: </label>
    </div>
  );
}

export default function DebugMenu(props) {
  const { t, i18n } = useTranslation();
  const [context, setContext] = useState(props.context);

  const changeLanguageHandler = (lang = "en") => {
    devLog("changeLanguageHandler", lang);
    context.setState({
      lang: lang,
    });
  };

  useEffect(() => {
    devLog("debug");
    setContext(props.context);
  }, [props]);

  useEffect(() => {
    devLog("reload context!");
    setContext(props.context);
  }, [props.context]);

  return (
    <>
      <div className="debugMenu" style={{ fontWeight: "bold" }}>
        <div>
          <div className="header">
            <h4>DEBUG</h4>
          </div>
          <hr />
          <button
            onClick={() => {
              if (typeof props.context.runTest === "function") {
                props.context.runTest();
              }
            }}
          >
            Test API
          </button>
          <br />
          <label htmlFor="Reset">Reset Local Storage--</label>
          <button name="Reset" onClick={localStorage.removeItem("TrxNowForm")}>
            Reset Local Storage
          </button>
          <br />
          <DebugMenuItem
            label={`Confirm Customer`}
            onSelect={() => context.setState({ webAppState: AppState.ConfirmCustomer })}
            selected={context.state.webAppState === AppState.ConfirmCustomer}
          />
          <DebugMenuItem
            label={`Contract Search`}
            onSelect={() => context.setState({ webAppState: AppState.MemberSearch })}
            selected={context.state.webAppState === AppState.MemberSearch}
          />
          <DebugMenuItem
            label={`Policy Information`}
            onSelect={() => context.setState({ webAppState: AppState.MemberInformation })}
            selected={context.state.webAppState === AppState.MemberInformation}
          />
          <DebugMenuItem
            label={`Confirm Vehicle`}
            onSelect={() => context.setState({ webAppState: AppState.ConfirmVehicle })}
            selected={context.state.webAppState === AppState.ConfirmVehicle}
          />
          <DebugMenuItem
            label={`Select Service`}
            onSelect={() => context.setState({ webAppState: AppState.SelectService })}
            selected={context.state.webAppState === AppState.SelectService}
          />
          <DebugMenuItem
            label={`Locate User`}
            onSelect={() => props.context.setState({ webAppState: AppState.LocateUser })}
            selected={context.state.webAppState === AppState.LocateUser}
          />
          <DebugMenuItem
            label={`Selected Destinations`}
            onSelect={() => context.setState({ webAppState: AppState.SelectDestination })}
            selected={context.state.webAppState === AppState.SelectDestination}
          />
          <DebugMenuItem
            label={`Confirm Information`}
            onSelect={() => context.setState({ webAppState: AppState.ConfirmInformation })}
            selected={context.state.webAppState === AppState.ConfirmInformation}
          />
          <DebugMenuItem
            label={`Locating Provider Container`}
            onSelect={() => context.setState({ webAppState: AppState.LocatingProvider })}
            selected={context.state.webAppState === AppState.LocatingProvider}
          />

          <DebugMenuItem
            label={`Payment Required Container`}
            onSelect={() => context.setState({ webAppState: AppState.PaymentRequired })}
            selected={context.state.webAppState === AppState.PaymentRequired}
          />
          <DebugMenuItem
            label={`Provider Enroute`}
            onSelect={() => context.setState({ webAppState: AppState.ProviderEnroute })}
            selected={context.state.webAppState === AppState.ProviderEnroute}
          />
          <DebugMenuItem
            label={`Feedback`}
            onSelect={() => context.setState({ webAppState: AppState.Feedback })}
            selected={context.state.webAppState === AppState.Feedback}
          />
          <DebugMenuItem
            label={`Text To Locate`}
            onSelect={() => context.setState({ webAppState: AppState.TTLocateUser })}
            selected={context.state.webAppState === AppState.TTLocateUser}
          />
          <DebugMenuItem
            label={`Temp`}
            onSelect={() => context.setState({ webAppState: AppState.Temp })}
            selected={context.state.webAppState === AppState.Temp}
          />
          <DebugMenuItem
            label={`TVL Accident Confirmed`}
            onSelect={() => context.setState({ webAppState: AppState.AccidentConfirmed })}
            selected={context.state.webAppState === AppState.AccidentConfirmed}
          />
          <DebugMenuItem
            label={`Partner Promotion`}
            onSelect={() => context.setState({ webAppState: AppState.PartnerPromotion })}
            selected={context.state.webAppState === AppState.PartnerPromotion}
          />
        </div>
        <br />
        <div>
          <h5>Change Language: {context?.state.lang}</h5>
          <hr />
          <div className="btn-group" role="group" aria-label="Basic example">
            <button
              className={`btn ${context?.state.lang == "en" ? "btn-secondary" : "btn-primary"}`}
              onClick={(e) => {
                changeLanguageHandler("en");
              }}
            >
              English
            </button>
            <button
              className={`btn ${context?.state.lang == "fr" ? "btn-secondary" : "btn-primary"}`}
              onClick={(e) => {
                changeLanguageHandler("fr");
              }}
            >
              French
            </button>
            <button
              className={`btn ${context?.state.lang == "es" ? "btn-secondary" : "btn-primary"}`}
              onClick={(e) => {
                changeLanguageHandler("es");
              }}
            >
              Spanish
            </button>
          </div>
        </div>
        <br />
        <div>
          <h5>App State Overrides:</h5>
          <hr />
          <DebugMenuItem
            label={`Tow Reason Restricted`}
            type="checkbox"
            onSelect={() =>
              props.context.setState({
                towReasonRestricted: !props.context.state.towReasonRestricted,
              })
            }
            selected={props.context.state.towReasonRestricted}
          />
          <DebugMenuItem
            label={`API Call Pending`}
            style={{ zIndex: 999999999 }}
            type="checkbox"
            onSelect={(selected) =>
              props.context.setState({
                apiCallPending: !props.context.state.apiCallPending,
              })
            }
            selected={props.context.state.apiCallPending}
          />
          <DebugMenuItem
            label={`DataHost Structure Member Search`}
            style={{ zIndex: 999999999 }}
            type="checkbox"
            onSelect={(selected) =>
              props.context.setState({
                dataHostStructure: !props.context.state.dataHostStructure,
              })
            }
            selected={props.context.state.dataHostStructure}
          />
        </div>
        <br />
        <div>
          <h5>App State:</h5>
          <hr />
          <table style={{ width: `100%` }}>
            <tbody>
              <tr>
                <td>
                  <b>Service: </b>
                </td>
                <td>{context.state.Service}</td>
              </tr>
              <tr>
                <td>
                  <b>Fuel Type: </b>
                </td>
                <td>{context.state.FuelType}</td>
              </tr>
              <tr>
                <td>
                  <b>Tow Reason: </b>
                </td>
                <td>{context.state.towReason}</td>
              </tr>
              <tr>
                <td>
                  <b>Year: </b>
                </td>
                <td>{context.state.Year}</td>
              </tr>
              <tr>
                <td>
                  <b>Make: </b>
                </td>
                <td>{context.state.Make}</td>
              </tr>
              <tr>
                <td>
                  <b>Model: </b>
                </td>
                <td>{context.state.Model}</td>
              </tr>
              <tr>
                <td>
                  <b>Color: </b>
                </td>
                <td>{context.state.Color}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
